import { Complaint } from '../Complaint'
import { formatYesNoToTrueFalse } from '../../utilities'
import { formSchema } from './schema'
import { qualityOfCare } from '../../strings/titles'
import { routePaths as routes } from '../../utilities/routePaths'
import { withBackButtonProtection } from '../../components/withBackButtonProtection'
import { withDocTitle } from '../../components/withDocTitle'
import withRecaptcha from '../withRecaptcha'

export class QualityOfCareComplaint extends Complaint {
  constructor(props) {
    super(props)
    this.complaintType = 'quality_of_care'
    this.schema = formSchema(this.saveFormData)
    this.successURL = routes.qualityofcare.confirmation
  }

  /*
   * Combine the QOC unique data with the common complaint data.
   */
  formatComplaintForRequest(formData) {
    // Process the data unique to this complaint.
    const { immediate_danger_yn } = formData

    const detail = {
      immediate_danger: formatYesNoToTrueFalse(immediate_danger_yn)
    }

    // Return the combined unique data and common data.
    return this.formatCommonComplaintFormData(formData, detail)
  }
}
export default withRecaptcha(
  withBackButtonProtection(withDocTitle(QualityOfCareComplaint, qualityOfCare))
)
